module.exports = (state, action) => {
  const { field, value } = action.payload
  state.me[field] = value
}
